import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Paginatable } from '@/modules/shared/helpers/http/paginatable'
import { Paginated } from '@/modules/shared/models/data'

@Component
export class VirtualScrollPaginatableMixin<T> extends Vue {
  protected get paginatable(): Paginatable<Paginated<T>> {
    throw new Error('must override paginatable')
  }

  protected get loading(): boolean {
    return this.paginatable.isInProgress()
  }

  onScroll({ to, ref }) {
    if (
      !this.loading &&
      this.paginatable.nextPage &&
      this.paginatable.nextPage <= this.paginatable.lastPage &&
      to === this.paginatable.lastIndex
    ) {
      this.paginatable
        .next()
        .then(() => {
          this.$nextTick(() => {
            ref.refresh()
          })
        })
    }
  }
}
